<template>

    <form id="visit-form" action="/visit/send" method="POST" class="grid lg:grid-cols-2 gap-y-12 sm:gap-y-12 2xl:gap-y-14 2.5xl:gap-y-16 3xl:gap-y-18 gap-x-10 xl:gap-x-12 2xl:gap-x-14">

        <input type="hidden" name="_token" :value="csrf">
        <input type="hidden" name="visit" :value="form.visit">
        <input type="hidden" name="_form_token" :value="formToken">
        <input type="hidden" name="lang" :value="lang">
        <span aria-hidden="true" style="position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;">
            <input type="text" name="website" tabindex="-1" autocomplete="off" value="">
        </span>

        <span class="relative block w-full col-span-2 lg:col-span-1">
            <span class="relative flex flex-col w-full text-white">
                <div class="w-full">
                    <date-picker :input-attr="{readonly: true}" name="date" :disabledDate="disabledDate" :append-to-body="false" v-model="form.date" :format="'DD/MM/YYYY'" valueType="format" @focus="validation.date.state = null, showPlaceholderDate = ''" :input-class="'pb-2 w-full px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer'"></date-picker>
                    <!-- <label class="text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all" :class="!showPlaceholderDate && '!text-xxs !-top-5'"> {{$root.translateString('date')}} </label> -->
                    <label class="text-white text-[20px] sm:text-[22px] md:text-[24px] lg:text-[26px] xl:text-[28px] 2xl:text-[30px] absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none transition-all" :class="!showPlaceholderDate && '!text-xs !-top-4'"> {{$root.translateString('date')}} </label>
                </div>
            </span>
            <span v-if="validation.date.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2">
                {{ validation.date.message }}
            </span>
        </span>

        <span class="relative block w-full col-span-2 lg:col-span-1">
            <span class="relative flex flex-col w-full text-white">
                <input @focus="validation.fullname.state = null" name="name" class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer" placeholder=" " type="fullname" v-model="form.fullname" />
                <label class="text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all">{{$root.translateString('name')}}</label>
            </span>
            <span v-if="validation.fullname.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2">
                {{ validation.fullname.message }}
            </span>
        </span>

        <span class="relative block w-full col-span-2 lg:col-span-1">
            <span class="relative flex flex-col w-full text-white">
                <input @focus="validation.email.state = null" name="email" class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer" placeholder=" " type="email" v-model="form.email" />
                <label class="text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all">E-mail</label>
            </span>
            <span v-if="validation.email.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2">
                {{ validation.email.message }}
            </span>
        </span>

        <span class="relative block w-full col-span-2 lg:col-span-1">
            <span class="relative flex flex-col w-full text-white">
                <input @focus="validation.phone.state = null" name="phone" class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer" placeholder=" " type="tel" v-model="form.phone" />
                <label class="text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all">{{$root.translateString('phone')}}</label>
            </span>
            <span v-if="validation.phone.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2">
                {{ validation.phone.message }}
            </span>
        </span>

        <span class="relative block w-full col-span-2 lg:col-span-1">
            <span class="relative flex flex-col w-full text-white">
                <div class="w-full">
                    <date-picker name="birthdate" :input-attr="{readonly: true, name: 'birth_date'}" :disabledDate="disabledDateBirthDate" :append-to-body="false" v-model="form.birth_date" :format="'DD/MM/YYYY'" valueType="format" @focus="validation.birth_date.state = null, showPlaceholderBirthDate = ''" :input-class="'pb-2 w-full px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer'"></date-picker>
                    <label class="text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all" :class="!showPlaceholderBirthDate && '!text-xxs !-top-5'"> {{$root.translateString('birth-date')}} </label>
                </div>
            </span>
            <span v-if="validation.birth_date.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2">
                {{ validation.birth_date.message }}
            </span>
        </span>

        <span class="relative block w-full col-span-2 lg:col-span-1">
            <span class="relative flex flex-col w-full text-white">
                <input @focus="validation.adults.state = null" name="adults" class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer" placeholder=" " type="number" v-model="form.adults" />
                <label class="text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all">{{$root.translateString('participants')}}</label>
            </span>
            <span v-if="validation.adults.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2">
                {{ validation.adults.message }}
            </span>
        </span>

        <!-- <span class="relative block w-full col-span-2 lg:col-span-1">
            <span class="relative flex flex-col w-full text-white">
                <input @focus="validation.kids.state = null"  name="kids" class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer" placeholder=" " type="number" v-model="form.kids" />
                <label class="text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all">{{$root.translateString('kids')}}</label>
            </span>
            <span v-if="validation.kids.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2">
                {{ validation.fullname.message }}
            </span>
        </span> -->

        <span class="relative block w-full col-span-2">
            <span class="relative flex flex-col w-full text-white">
                <textarea @focus="validation.message.state = null" name="message" rows="5" class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[50px] text-white text-1.5xl 2xl:text-2xl text-center peer" placeholder=" " v-model="form.message"></textarea>
                <label class="text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all">{{$root.translateString('notes')}}</label>
            </span>
            <span v-if="validation.message.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2">
                {{ validation.message.message }}
            </span>
        </span>

        <span class="flex flex-col items-center justify-center w-full col-span-2 space-y-10 sm:flex-row sm:space-y-0 sm:space-x-3">
            <span class="flex flex-col flex-grow space-y-4">

                <span class="flex flex-col flex-grow">
                    <span class="flex items-center space-x-3">
                        <span class="w-[30px] h-[30px] relative block">
                            <input @click="validation.privacy.state = null" name="contact-privacy" id="contact-privacy" class="absolute top-0 left-0 w-full h-full outline-none opacity-0 accent-transparent ring-0" type="checkbox" v-model="form.privacy">
                            <span class="absolute top-0 left-0 w-full h-full bg-center bg-no-repeat border pointer-events-none fake-checkbox border-white/50"></span>
                        </span>
                        <label for="contact-privacy" class="cursor-pointer">
                            <span class="text-[18px] md:text-[19px] xl:text-[20px] font-light text-white/50">
                                {{$root.translateString('accept')}}
                            </span>
                            <a class="text-[18px] md:text-[19px] xl:text-[20px] font-light underline transition-all text-white/50 hover:text-white/100" :href="'/' + lang + '/privacy-policy'">
                                {{$root.translateString('link')}}
                            </a>
                        </label>
                    </span>
                    <span v-if="validation.privacy.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center justify-start mt-2">
                        {{ validation.privacy.message }}
                    </span>
                </span>

                <span class="flex items-center space-x-3">
                    <span class="w-[30px] h-[30px] relative block">
                        <input name="marketing" id="marketing" class="absolute top-0 left-0 w-full h-full outline-none opacity-0 accent-transparent ring-0" type="checkbox" v-model="form.marketing">
                        <span class="absolute top-0 left-0 w-full h-full bg-center bg-no-repeat border pointer-events-none fake-checkbox border-white/50"></span>
                    </span>
                    <label for="marketing" class="cursor-pointer">
                        <span class="text-[18px] md:text-[19px] xl:text-[20px] font-light text-white/50">
                            {{$root.translateString('marketing')}}
                        </span>
                    </label>
                </span>

            </span>

            <span>
                <button v-if="!loading" @click="checkForm" type="button" class="relative flex items-center group transition-all space-x-3.5">
                    <span class="rounded-full bg-white/20 group-hover:bg-white w-[40px] h-[40px] flex justify-center items-center transition-all">

                        <svg class="text-primary-400" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="21.414px" height="15.683px" viewBox="0 0 21.414 15.683" enable-background="new 0 0 21.414 15.683" xml:space="preserve">
                            <g>
                                <line fill="none" stroke="currentColor" stroke-miterlimit="10" x1="0" y1="7.841" x2="20.715" y2="7.841"/>
                                <polyline fill="none" stroke="currentColor" stroke-miterlimit="10" points="13.219,0.354 20.707,7.841 13.219,15.329 	"/>
                            </g>
                        </svg>

                    </span>
                    <span class="text-primary-300 text-[18px] md:text-[19px] xl:text-[20px] font-light group-hover:text-white transition-all">
                        {{$root.translateString('send')}}
                    </span>
                </button>
                <svg class="h-[30px] w-[30px] text-white" v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                    </circle>
                </svg>
            </span>
        </span>
    </form>

</template>

<script>

    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    import 'vue2-datepicker/locale/it';
    import 'vue2-datepicker/locale/en';

    export default {

        components: {
            DatePicker
        },

        props: ['lang', 'formToken'],

        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                error: false,
                sending: false,
                showPlaceholderDate: true,
                showPlaceholderBirthDate: false,
                loading: false,
                selectedVisit: '',
                majorDate: null,
                form: {
                    visit: '',
                    date: null,
                    fullname: '',
                    email: '',
                    phone: '',
                    adults: 2,
                    //kids: '',
                    birth_date: null,
                    message: '',
                    marketing: false,
                    privacy: false
                },
                validation: {
                    date: {
                        state: null,
                        message: '',
                    },
                    fullname: {
                        state: null,
                        message: '',
                    },
                    email: {
                        state: null,
                        message: '',
                    },
                    phone: {
                        state: null,
                        message: '',
                    },
                    adults: {
                        state: null,
                        message: '',
                    },
                    kids: {
                        state: null,
                        message: '',
                    },
                    birth_date: {
                        state: null,
                        message: '',
                    },
                    message: {
                        state: null,
                        message: '',
                    },
                    privacy: {
                        state: null,
                        message: '',
                    },
                },
            }
        },

        created() {
            const subtractFromDate = (
                date,
                { years, days, hours, minutes, seconds, milliseconds } = {}
            ) => {
                const millisecondsOffset = milliseconds ?? 0
                const secondsOffset = seconds ? 1000 * seconds : 0
                const minutesOffset = minutes ? 1000 * 60 * minutes : 0
                const hoursOffset = hours ? 1000 * 60 * 60 * hours : 0
                const daysOffset = days ? 1000 * 60 * 60 * 24 * days : 0
                const dateOffset =
                    millisecondsOffset +
                    secondsOffset +
                    minutesOffset +
                    hoursOffset +
                    daysOffset

                let newDate = date
                if (years) newDate = date.setFullYear(date.getFullYear() - years)
                newDate = new Date(newDate - dateOffset)

                return newDate
            }

            this.majorDate = subtractFromDate(new Date(), { years: 18 })
            this.form.birth_date = this.convertDate(this.majorDate)
        },

        mounted() {

            window.addEventListener('message', (event) => {
                if(event.data.type === 'selectVisit'){
                    this.form.visit = event.data.content
                }
                if(event.data.type === 'emptyForm'){
                    this.resetForm()
                }
            }, false)

            /* */

        },

        methods: {

            convertDate(inputFormat) {
                function pad(s) { return (s < 10) ? '0' + s : s; }
                var d = new Date(inputFormat)
                return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/')
            },

            disabledDate(date) {
                return date < new Date();
            },

            disabledDateBirthDate(date) {
                return date > Date.parse(this.majorDate);
            },

            resetForm() {
                this.form = {
                    visit: '',
                    date: null,
                    fullname: '',
                    email: '',
                    phone: '',
                    adults: 2,
                    //kids: '',
                    birth_date: null,
                    message: '',
                    privacy: false
                }
                this.showPlaceholderDate = true
                this.showPlaceholderBirthDate = true
            },

            checkForm() {

                this.sending = true;
                let error = false;

                //if(this.form.kids == '') this.form.kids = 0

                Object.keys(this.validation).forEach(key => {
                    this.validation[key].state = null;
                });

                if(this.form.date == null) {
                    this.validation.date.message = this.$root.translateString('form-mandatory');
                    this.validation.date.state = false;
                    error = true;
                }

                if(this.form.fullname == '') {
                    this.validation.fullname.message = this.$root.translateString('form-mandatory');
                    this.validation.fullname.state = false;
                    error = true;
                }

                if(this.form.email == '') {
                    this.validation.email.message = this.$root.translateString('form-mandatory');
                    this.validation.email.state = false;
                    error = true;
                }

                if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email))) {
                    this.validation.email.message = this.$root.translateString('form-format');
                    this.validation.email.state = false;
                    error = true;
                }

                /*if(this.form.country == '') {
                    this.validation.country.message = this.$root.translateString('form-mandatory');
                    this.validation.country.state = false;
                    error = true;
                }*/

                if(this.form.phone == '' || ( this.form.phone != '' && !(/^[+()\d-]+$/.test(this.form.phone)) ) ) {
                    this.validation.phone.message = this.$root.translateString('form-format');
                    this.validation.phone.state = false;
                    error = true;
                }

                if(this.form.adults == '') {
                    this.validation.message.adults = this.$root.translateString('form-mandatory');
                    this.validation.message.state = false;
                    error = true;
                }

                if(this.form.message == '') {
                    this.validation.message.message = this.$root.translateString('form-mandatory');
                    this.validation.message.state = false;
                    error = true;
                }

                if(this.form.privacy === false) {
                    this.validation.privacy.message = this.$root.translateString('form-mandatory');
                    this.validation.privacy.state = false;
                    error = true;
                }

                if(!error) {
                    this.loading = true
                    this.sendMail()
                }else{
                    this.sending = false;
                }

            },

            sendMail() {
                setTimeout(() => {
                    document.querySelector('#visit-form').submit()
                }, 500);
            }

        }
    }
</script>

<style>

    .mx-datepicker{
        width:100%;
    }

    .mx-input-wrapper .mx-input{
        width: 100%;
        height: 100%;
        padding: 0 !important;
        padding-left: 10px;
        font-size: inherit;
        text-align: center;
        line-height: 1.4;
        color: inherit;
        background-color: transparent;
        border: 0;
        border-radius: 0;
    }

    .mx-icon-calendar{
        display:none
    }

    .mx-datepicker-main{
        color: #ffffff !important;
        background-color: #000 !important;
        border: 1px solid #ffffff !important;
    }

    .mx-datepicker-popup{
        margin-top: -1px !important;
    }

    .mx-btn, .mx-table-date td, .mx-table-date th{
        color: #ffffff !important;
        font-size: .9rem !important;
        text-transform: uppercase !important;
    }

    .mx-calendar{
        width: 340px !important;
        padding: 6px 6px !important;

    }

    .mx-calendar-header{
        padding: 0px 12px !important;
    }

    .mx-calendar-content .cell {
        text-transform: uppercase !important;
    }

    .mx-calendar-content .cell:hover {
        background-color: #b5945b;
        transition:all 200ms;
        color: #ffffff;
    }

    .mx-calendar-content .cell.active {
        color: #ffffff;
        background-color: #9f7f49;
        transition:all 200ms;
    }

    .mx-datepicker-popup{
        left: 50% !important;
        transform: translateX(-50%);
    }

    .mx-calendar-content .cell.disabled{
        background-color: transparent;
        opacity: .5;
    }

</style>
